import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Input } from 'app/ui_components/tags';

const FieldGroup = styled.form`
  position: relative;
`;

const Label = styled.label`
  visibility: ${({ isFocused }) => isFocused ? 'visible' : 'hidden'};
  background: transparent;
  position: absolute;
  padding: 5px;
  top: 0px;
  left: 8px;
  transition: transform 300ms, fontSize 300ms;
  pointer-events: none;
  font-size: 12px;
  text-align: center;
  ${({isFocused}) => isFocused ? activeLabelStyles : ''}

  &:after  {
      background-color: white;
      content: '';
      display: block;
      width: 100%;
      height: 3px;
      position: absolute;
      top: 17px;
      z-index: -1;
      left: 0;
  }

  `;

const activeLabelStyles = `
  -webkit-transform: translateY(-18px);
  transform: translateY(-18px);
`;

class FloatingLabelInput extends React.Component {
  static propTypes = {
    handleChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    autoFocus: PropTypes.bool
  };

  static defaultProps = {
    label: '',
    size: 15
  }

  state = {
    isFocused: false
  }

  componentDidMount() {
    const { autoFocus } = this.props;

    if (autoFocus) {
      this.setState({ isFocused: true });
    }
  }

  handleFocus = () => this.setState({ isFocused: true });

  handleBlur = () => this.setState({ isFocused: false });

  render() {
    const { label, placeholder, size, handleChange, ...props } = this.props;
    const { isFocused } = this.state;

    return (
      <FieldGroup>
        <Input
          placeholder={isFocused ? '' : placeholder}
          onFocus={() => this.handleFocus()}
          onBlur={() => this.handleBlur()}
          onChange={handleChange}
          {...props}
        />
        <Label
          size= {size}
          isFocused={isFocused}
        >
          {label}
        </Label>
      </FieldGroup>
    );
  }
}

export default FloatingLabelInput;
